import {
  PermittingWorkflowBody,
  PermittingWorkflowBodyOptions,
} from '@models/interfaces';
import { PaceTasksToObjectMapper, WorkflowData } from '../models';

const transform = <T extends Record<string, any>>(
  data: T,
  options: PaceTasksToObjectMapper.Options[],
): PermittingWorkflowBodyOptions[] =>
  Object.keys(data).reduce(
    (acc: PermittingWorkflowBodyOptions[], key: string) => {
      const currentOption = options.find(
        (opt: PaceTasksToObjectMapper.Options) => opt.fieldKey === key,
      );

      return !currentOption
        ? acc
        : [
            ...acc,
            {
              task: currentOption.task,
              fieldKey: currentOption.fieldKey,
              value: data[key as keyof T],
            },
          ];
    },
    [],
  );

export const dataToPaceTasksMapper = (
  data: WorkflowData,
  permittingSectionOptions: PaceTasksToObjectMapper.Options[],
  zoningSectionOptions: PaceTasksToObjectMapper.Options[],
): PermittingWorkflowBody => ({
  ...data,
  permittingSection: transform(
    data.permittingSection,
    permittingSectionOptions,
  ),
  zoningSection: transform(data.zoningSection, zoningSectionOptions),
});
